import { Logger, LoggerLevel } from '../lib/logger/Logger';

export const logger = new Logger({ level: LoggerLevel.Debug });
